import { onMounted, type MaybeRef, computed, type ComputedRef } from 'vue';
import Cookies from 'js-cookie';
import { useScreenSize } from '@experience/shared';

const FORCED_CLOSE_COOKIE_KEY = '_ocf_close';
const LISTING_VISIT_COOKIE_KEY = '_ocf_visit';
const FORCED_CLOSE_HOURS = 8;
const SAME_LISTING_MINUTES = 30;

export function useForcedCalendar(popupRef: MaybeRef, currentSlug: ComputedRef<string>) {
  const { isMobile } = useScreenSize();

  const shouldShowModal = computed(() => {
    const forcedClose = Cookies.get(FORCED_CLOSE_COOKIE_KEY);
    if (forcedClose === '1') {
      return false;
    }

    const lastVisit = Cookies.get(LISTING_VISIT_COOKIE_KEY);

    return isMobile.value && lastVisit !== toValue(currentSlug);
  });

  const updateListingVisit = () => {
    if (currentSlug) {
      const expires = new Date(Date.now() + SAME_LISTING_MINUTES * 60 * 1000);
      Cookies.set(LISTING_VISIT_COOKIE_KEY, toValue(currentSlug), { expires });
    }
  };

  const calendarApply = (isForced: boolean) => {
    if (isForced) {
      Cookies.remove(FORCED_CLOSE_COOKIE_KEY);
    }
  };

  const calendarClose = (isForced: boolean) => {
    if (isForced) {
      const expires = new Date(Date.now() + FORCED_CLOSE_HOURS * 60 * 60 * 1000);
      Cookies.set(FORCED_CLOSE_COOKIE_KEY, '1', { expires });
    }
  };

  const openModal = () => {
    popupRef.value?.open(true);
  };

  onMounted(() => {
    if (shouldShowModal.value) {
      openModal();
      updateListingVisit();
    }
  });

  return {
    calendarApply,
    calendarClose,
  };
}
